import { extractTextFromQuery } from '../../../utils/query-utils';

export default {
  param: extractTextFromQuery,
  query: function(text) {
    const words = text.trim().split(' ');

    if (text) {
      return {
        $or: [
          {
            $or: words.map(function(word) {
              return {
                project: {
                  $where: {
                    creator: {
                      $where: {
                        firstName: {
                          $ilike: `%${word}%`
                        }
                      }
                    }
                  }
                }
              };
            }).concat(words.map(function(word) {
              return {
                project: {
                  $where: {
                    creator: {
                      $where: {
                        lastName: {
                          $ilike: `%${word}%`
                        }
                      }
                    }
                  }
                }
              };
            }))
          },
          {
            $or: words.map(function(word) {
              return {
                event: {
                  $where: {
                    creator: {
                      $where: {
                        firstName: {
                          $ilike: `%${word}%`
                        }
                      }
                    }
                  }
                }
              };
            }).concat(words.map(function(word) {
              return {
                event: {
                  $where: {
                    creator: {
                      $where: {
                        lastName: {
                          $ilike: `%${word}%`
                        }
                      }
                    }
                  }
                }
              };
            }))
          }
        ]
      }
    }
  }
}
